const $755957079a54393b$export$de7ead42144ee87f = document.querySelector(":root");
function $755957079a54393b$export$71511d61b312f219(id) {
    return document.getElementById(id);
}
function $755957079a54393b$export$3d8c2f653ac9d0b9(parent, selector) {
    return Array.from(parent.querySelectorAll(selector));
}



function $9ba8302e2b54bc97$export$2e2bcd8739ae039({ addBtn: addBtn, events: events, action: action }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        initialized = true;
        _addListeners();
    }
    function _addListeners() {
        addBtn.addEventListener("click", (e)=>{
            events.emit(action);
        });
    }
}



function $e3e66118ecb9a43a$export$2e2bcd8739ae039({ header: header, logo: logo }) {
    const COLLAPSED_HEADER_HEIGHT = 50;
    const EXPANDED_HEADER_HEIGHT = 90;
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (initialized) return;
        initialized = true;
        _addScrollListener();
    }
    function _addScrollListener() {
        window.addEventListener("scroll", (e)=>{
            const scrollTop = Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
            _handleHeaderOnScroll(scrollTop);
        });
    }
    function _handleHeaderOnScroll(scrollTop) {
        if (scrollTop > 0) _collapseHeader();
        else _expandHeader();
    }
    function _collapseHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", COLLAPSED_HEADER_HEIGHT + "px");
        header.classList.add("header-collapsed");
        logo.classList.add("logo-collapsed");
    }
    function _expandHeader() {
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--headerHeight", EXPANDED_HEADER_HEIGHT + "px");
        header.classList.remove("header-collapsed");
        logo.classList.remove("logo-collapsed");
    }
}



class $f6e6a130867ac54c$export$2e2bcd8739ae039 {
    _overlay;
    _redirectUrl;
    _overlayBox;
    constructor(overlay, redirectUrl){
        this._overlay = overlay;
        this._redirectUrl = redirectUrl;
        this._addOnCloseListener();
        this._overlayBox = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-box")[0];
    }
    set(redirectUrl) {
        this._redirectUrl = redirectUrl;
    }
    render(content) {
        const wrapper = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(this._overlay, ".overlay-content")[0];
        wrapper.replaceChildren();
        wrapper.append(content);
        this.show();
    }
    show() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-scroll");
        this._overlay.classList.add("overlay-change");
        this._overlayBox.classList.add("overlay-box-change");
    }
    _addOnCloseListener() {
        this._overlay.addEventListener("click", (e)=>{
            this._onClose(e);
        });
    }
    _onClose(e) {
        const target = e.target;
        if (target === this._overlay) this.hide();
    }
    hide() {
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-scroll");
        this._overlayBox.classList.remove("overlay-box-change");
        setTimeout(()=>{
            this._overlay.classList.remove("overlay-change");
            if (this._redirectUrl) window.location.href = this._redirectUrl;
        }, 300);
    }
}


function $0916120d17a98724$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay }) {
    let initialized = false;
    return Object.freeze({
        init: init
    });
    function init() {
        if (!settingsBtn || !settingsOverlay) return;
        if (initialized) return;
        const SettingsOverlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(settingsOverlay);
        settingsBtn.addEventListener("click", ()=>{
            SettingsOverlay.show();
        });
        initialized = true;
    }
}



function $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr) {
    const el = document.createElement(tag);
    el.setAttribute("class", classes);
    if (attr) for(let key in attr)el.setAttribute(key, attr[key]);
    return el;
}
function $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerText = text;
    return el;
}
function $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    el.innerHTML = html;
    return el;
}
function $9eeef69b55ee9859$export$ee31727d4121fca7(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("img", classes, attr);
}
function $9eeef69b55ee9859$export$f235d743d35a42d0(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("audio", classes, attr);
}
function $9eeef69b55ee9859$export$c34ace1158f06c39(classes, attr) {
    return $9eeef69b55ee9859$export$3d7cd8ed57263b30("video", classes, attr);
}
function $9eeef69b55ee9859$export$258b0eb2f6f9eed2(classes, attr) {
    return $9eeef69b55ee9859$export$ecd10de24f44b999("button", classes, attr.text, attr);
}
function $9eeef69b55ee9859$export$5a1947d71e311350(classes, attr) {
    const btn = $9eeef69b55ee9859$export$3d7cd8ed57263b30("button", classes, attr);
    const spinner = $9eeef69b55ee9859$export$3d7cd8ed57263b30("div", "spinner no-display");
    const span = $9eeef69b55ee9859$export$ecd10de24f44b999("span", "btn-span", attr.text);
    btn.append(spinner, span);
    return btn;
}
function $9eeef69b55ee9859$export$407ea597bae49e98(fragments) {
    const fragment = document.createDocumentFragment();
    fragments.forEach((fr)=>fragment.append(fr));
    return fragment;
}
function $9eeef69b55ee9859$export$aefe1a6be41e3d0c(tag, classes, target, attr) {
    const el = $9eeef69b55ee9859$export$3d7cd8ed57263b30(tag, classes, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$e7e97c57fc2e401c(tag, classes, target, text, attr) {
    const el = $9eeef69b55ee9859$export$ecd10de24f44b999(tag, classes, text, attr);
    target.append(el);
}
function $9eeef69b55ee9859$export$87eb1d92205d639(tag, classes, target, html, attr) {
    const el = $9eeef69b55ee9859$export$69b2a7fcb8b634f(tag, classes, html, attr);
    target.append(el);
}



function $cd86d6b806a138de$export$2e2bcd8739ae039(action, data) {
    const ev = new CustomEvent("form-event-with-data", {
        detail: {
            action: action,
            data: data
        }
    });
    window.dispatchEvent(ev);
}



function $199f5777ad933961$export$2e2bcd8739ae039({ forms: forms, overlayEl: overlayEl, entity: entity, events: events, action: action }) {
    let initialized = false;
    let DELETE_PROMPT;
    const FORMS = [];
    return Object.freeze({
        init: init,
        update: update,
        add: add,
        remove: remove,
        validateForm: validateForm,
        getById: getById,
        submit: submit
    });
    function _findByIndex(index) {
        return FORMS.find((form)=>form.id === index);
    }
    function getById(index) {
        const form = _findByIndex(index);
        if (!form) return null;
        return {
            form: form.form,
            submitBtn: form.submitBtn
        };
    }
    function init() {
        if (initialized) return;
        DELETE_PROMPT = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)(overlayEl);
        for(let i = 0; i < forms.length; i++){
            FORMS.push(_newForm(forms[i], i));
            _addListeners(FORMS[i]);
        }
        initialized = true;
    }
    // ---------- ADD NEW FORM
    function _newForm(formEl, i) {
        return {
            form: formEl,
            id: i,
            formId: formEl.getAttribute("data-id"),
            deleteBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formEl, ".delete-btn")[0],
            submitBtn: (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formEl, ".submit-btn")[0]
        };
    }
    function add() {
        const lastIndex = FORMS.length - 1;
        const origForm = FORMS[lastIndex].form;
        const newForm = origForm.cloneNode(true);
        const newFormObj = _newForm(newForm, FORMS[lastIndex].id + 1);
        _resetForm(newFormObj);
        _changeSubmitBtnText(newFormObj.submitBtn, `Add ${entity}`);
        _hideDeleteBtn(newFormObj.deleteBtn);
        _addListeners(newFormObj);
        FORMS.push(newFormObj);
        origForm.after(newForm);
        return newFormObj.id;
    }
    function _addListeners(formObj) {
        formObj.form.addEventListener("submit", (e)=>{
            e.preventDefault();
            _onFormSubmit(formObj);
        });
        formObj.deleteBtn.addEventListener("click", (e)=>_onDelete(formObj));
    }
    function _resetForm(formObj) {
        const { form: form } = formObj;
        formObj.formId = null;
        form.removeAttribute("data-id");
        form.removeAttribute("data-src");
        const inputs = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".input-fields");
        const checkBoxes = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, `input[type="checkbox"]`);
        checkBoxes.forEach((checkbox)=>checkbox.checked = false);
        const duplicables = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(form, ".duplicable");
        for(let i = 1; i < duplicables.length; i++)duplicables[i].remove();
        inputs.forEach((input)=>{
            input.value = "";
            input.removeAttribute("value");
            input.innerHTML = "";
        });
    }
    function _changeSubmitBtnText(submitBtn, text) {
        const buttonText = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, "span")[0];
        buttonText.innerText = text;
    }
    function _hideDeleteBtn(deleteBtn) {
        deleteBtn.classList.add("no-display");
    }
    // ---------- ON FORM SUBMIT
    function submit(index) {
        const form = _findByIndex(index);
        if (!form) return;
        _onFormSubmit(form);
    }
    function _onFormSubmit(formObj) {
        const { id: id, formId: formId, form: form, submitBtn: submitBtn } = formObj;
        if (!formId) {
            (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-created", {
                id: id,
                form: form,
                submitBtn: submitBtn
            });
            return;
        }
        (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-updated", {
            index: id,
            id: formId,
            form: form,
            submitBtn: submitBtn
        });
    }
    function update(index, formId) {
        const form = _findByIndex(index);
        if (!form) return;
        form.formId = formId;
        _changeSubmitBtnText(form.submitBtn, "Update");
        form.deleteBtn.classList.remove("no-display");
    }
    function validateForm(index) {
        const formObj = _findByIndex(index);
        if (!formObj) return;
        let isValid = true;
        const inputs = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(formObj.form, ".input-fields");
        inputs.every((input)=>{
            if (!input.checkValidity()) {
                input.focus();
                isValid = false;
                return false;
            }
            return true;
        });
        return isValid;
    }
    // ---------- DELETE FORM HANDLING
    function remove(id) {
        const formIndex = FORMS.findIndex((form)=>form.formId === id);
        if (formIndex === -1) return;
        if (FORMS.length === 1) events.emit(action); //avoid having no forms to clone
        FORMS[formIndex].form.remove();
        FORMS.splice(formIndex, 1);
    }
    function _onDelete(formObj) {
        if (!formObj.formId) return;
        _renderDeletePrompt(formObj.formId);
    }
    function _renderDeletePrompt(id) {
        const confirmBtn = (0, $9eeef69b55ee9859$export$5a1947d71e311350)("btns submit-btn", {
            type: "button",
            text: "Yes",
            title: "Yes"
        });
        const cancelBtn = (0, $9eeef69b55ee9859$export$258b0eb2f6f9eed2)("btns submit-btn error-btn", {
            type: "button",
            text: "No",
            title: "No"
        });
        const form = (0, $9eeef69b55ee9859$export$3d7cd8ed57263b30)("form", "flex-container flex-center prompt-btns");
        form.append(confirmBtn, cancelBtn);
        const fragments = [
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", "text-center", `Delete ${entity}`),
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("p", "text-center", `Are you sure you want to delete this ${entity.toLowerCase()}?`),
            form
        ];
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        DELETE_PROMPT.render(fragment);
        confirmBtn.addEventListener("click", (e)=>{
            (0, $cd86d6b806a138de$export$2e2bcd8739ae039)("form-deleted", {
                id: id,
                form: form,
                submitBtn: confirmBtn
            });
        });
        cancelBtn.addEventListener("click", (e)=>DELETE_PROMPT.hide());
    }
}


function $58f9f437543be56c$export$2e2bcd8739ae039(actions) {
    let events = [];
    actions.forEach((action)=>{
        events.push({
            event: new CustomEvent("app-event", {
                detail: {
                    action: action
                }
            }),
            action: action
        });
    });
    return Object.freeze({
        emit: emit
    });
    function emit(action) {
        const ev = events.find((event)=>event.action === action);
        window.dispatchEvent(ev.event);
    }
}


const $f5e68e8af16d89cf$var$actions = [
    "add-show-clicked"
];
const $f5e68e8af16d89cf$var$ACTIONS = [
    ...$f5e68e8af16d89cf$var$actions
];
const $f5e68e8af16d89cf$var$APP_EVENTS = (0, $58f9f437543be56c$export$2e2bcd8739ae039)($f5e68e8af16d89cf$var$ACTIONS);
var $f5e68e8af16d89cf$export$2e2bcd8739ae039 = $f5e68e8af16d89cf$var$APP_EVENTS;


const $da8fed51ab1f97e9$var$forms = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".form");
const $da8fed51ab1f97e9$var$showsForms = (0, $199f5777ad933961$export$2e2bcd8739ae039)({
    forms: $da8fed51ab1f97e9$var$forms,
    overlayEl: (0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"),
    entity: "Show",
    events: (0, $f5e68e8af16d89cf$export$2e2bcd8739ae039),
    action: "add-show-clicked"
});
const $da8fed51ab1f97e9$var$APP_COMPONENTS = Object.freeze({
    showsForms: $da8fed51ab1f97e9$var$showsForms
});
var $da8fed51ab1f97e9$export$2e2bcd8739ae039 = $da8fed51ab1f97e9$var$APP_COMPONENTS;



var $447f7b63ce62b2c2$export$2e2bcd8739ae039 = {
    execute: async ()=>{
        (0, $da8fed51ab1f97e9$export$2e2bcd8739ae039).showsForms.add();
    }
};



function $9c5c4c45b9fa185f$export$2e2bcd8739ae039({ btn: btn }) {
    const submitBtn = btn;
    const spinner = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".spinner")[0];
    const buttonSpan = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(submitBtn, ".btn-span")[0];
    return Object.freeze({
        reset: reset,
        onLoading: onLoading
    });
    function reset() {
        _btnLoader(false);
    }
    function onLoading() {
        _btnLoader(true);
    }
    function _btnLoader(isLoading) {
        if (isLoading) {
            submitBtn.disabled = true;
            spinner.classList.remove("no-display");
            buttonSpan.classList.add("no-display");
        } else {
            submitBtn.disabled = false;
            spinner.classList.add("no-display");
            buttonSpan.classList.remove("no-display");
        }
    }
}



function $01df58dec21e7277$export$2e2bcd8739ae039({ form: form, submitBtn: submitBtn }) {
    _preventSubmit();
    const LOADER = (0, $9c5c4c45b9fa185f$export$2e2bcd8739ae039)({
        btn: submitBtn
    });
    LOADER.onLoading();
    return Object.freeze({
        afterResponse: afterResponse
    });
    function afterResponse(resetForm) {
        _enableSubmit();
        LOADER.reset();
        if (resetForm) form?.reset();
    }
    function _preventSubmit() {
        document.addEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.add("no-pointers");
    }
    function _enableSubmit() {
        document.removeEventListener("keydown", _onPreventFormSubmit);
        (0, $755957079a54393b$export$de7ead42144ee87f).classList.remove("no-pointers");
    }
    function _onPreventFormSubmit(e) {
        if (e.code === "Enter") e.preventDefault(); //avoid submitting form
    }
}





function $e3d294463b74ae93$export$e4dd48968eea87b5() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 50 50");
    svg.setAttribute("width", "30");
    svg.setAttribute("height", "30");
    svg.setAttribute("transform", "scale(0.7)");
    svg.innerHTML = `
        <path fill="#00bf6f"
            d="m25,0.572441c-13.489683,0 -24.427559,10.937876 -24.427559,24.427559c0,13.489683 10.937876,24.427559 24.427559,24.427559c13.489683,0 24.427559,-10.937876 24.427559,-24.427559c0,-13.489683 -10.937876,-24.427559 -24.427559,-24.427559zm12.530029,16.259594l-15.169078,19.465711c-0.119957,0.119957 -0.31625,0.381681 -0.556163,0.381681c-0.250819,0 -0.414396,-0.174483 -0.556163,-0.31625c-0.141767,-0.141767 -8.604171,-8.277017 -8.604171,-8.277017l-0.163577,-0.163577c-0.065431,-0.098146 -0.119957,-0.218103 -0.119957,-0.348965c0,-0.130862 0.054526,-0.250819 0.119957,-0.348965c0.043621,-0.043621 0.076336,-0.076336 0.119957,-0.130862c0.839697,-0.883318 2.540902,-2.671764 2.649954,-2.780816c0.141767,-0.141767 0.261724,-0.327155 0.523448,-0.327155c0.272629,0 0.447112,0.229008 0.577973,0.35987c0.130862,0.130862 4.907322,4.721934 4.907322,4.721934l12.137443,-15.594379c0.109052,-0.087241 0.239914,-0.152672 0.381681,-0.152672c0.141767,0 0.272629,0.054526 0.381681,0.141767l3.336979,2.628144c0.087241,0.109052 0.141767,0.239914 0.141767,0.381681c0.010905,0.141767 -0.043621,0.261724 -0.109052,0.35987z" />`;
    return svg;
}
function $e3d294463b74ae93$export$2b895fe12934f65() {
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("viewBox", "0 0 64 64");
    svg.setAttribute("width", "50");
    svg.setAttribute("height", "50");
    svg.innerHTML = `
        <path fill="#ff618a" d="M30.16,11.51,6.84,51.9a2.13,2.13,0,0,0,1.84,3.19H55.32a2.13,2.13,0,0,0,1.84-3.19L33.84,11.51A2.13,2.13,0,0,0,30.16,11.51Z"/>
        <path fill="#1e1f29" d="M29,46a3,3,0,1,1,3,3A2.88,2.88,0,0,1,29,46Zm1.09-4.66-.76-15h5.26l-.73,15Z"/>`;
    return svg;
}


function $bac9fd8885449360$var$makeResponse() {
    const overlay = new (0, $f6e6a130867ac54c$export$2e2bcd8739ae039)((0, $755957079a54393b$export$71511d61b312f219)("resultOverlay"));
    return Object.freeze({
        show: show
    });
    function show({ ...args }) {
        const classes = args.resp.success ? "text-center" : "error text-center";
        const svg = args.resp.success ? (0, $e3d294463b74ae93$export$e4dd48968eea87b5)() : (0, $e3d294463b74ae93$export$2b895fe12934f65)();
        const textHTML = args.resp.success || args.resp.error ? args.respText : "A server-side error occured";
        const btnClasses = args.resp.success ? "submit-btn success-btn no-margin btns" : "submit-btn error-btn no-margin btns";
        const okBtn = (0, $9eeef69b55ee9859$export$258b0eb2f6f9eed2)(btnClasses, {
            type: "button",
            title: "OK",
            text: "OK"
        });
        const fragments = [
            (0, $9eeef69b55ee9859$export$ecd10de24f44b999)("h1", classes, args.respTitle),
            svg,
            (0, $9eeef69b55ee9859$export$69b2a7fcb8b634f)("p", classes, textHTML),
            okBtn
        ];
        const fragment = (0, $9eeef69b55ee9859$export$407ea597bae49e98)(fragments);
        overlay.render(fragment);
        if (args.onRedirect) overlay.set(args.onRedirect);
        okBtn.addEventListener("click", ()=>{
            overlay.hide();
        });
    }
}
const $bac9fd8885449360$var$ServerResponse = $bac9fd8885449360$var$makeResponse();
var $bac9fd8885449360$export$2e2bcd8739ae039 = $bac9fd8885449360$var$ServerResponse;


function $6f42e8eea5ca176e$var$makeRequest() {
    return Object.freeze({
        post: post
    });
    async function post(url, payload) {
        const options = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(payload)
        };
        try {
            const response = await fetch(url, options);
            return await response.json();
        } catch (err) {
            console.error(err);
            return {
                success: false,
                error: "An unexpected error occured<br><br>Please check your internet connection"
            };
        }
    }
}
const $6f42e8eea5ca176e$var$Request = $6f42e8eea5ca176e$var$makeRequest();
var $6f42e8eea5ca176e$export$2e2bcd8739ae039 = $6f42e8eea5ca176e$var$Request;



var $688b15fcee1bdf36$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { id: id, form: form, submitBtn: submitBtn } = data;
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/shows/delete", {
            id: id
        });
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Show deleted successfully.`
            });
            (0, $da8fed51ab1f97e9$export$2e2bcd8739ae039).showsForms.remove(id);
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};






var $4ac7df5f45edcabd$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { form: form, submitBtn: submitBtn } = data;
        const payload = {
            date: form.showdate.value,
            venue: form.venue.value.trim(),
            location: form.location.value.trim(),
            link: form.link.value.trim(),
            soldOut: form.soldout.checked
        };
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/shows/create", payload);
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Show added successfully.`
            });
            (0, $da8fed51ab1f97e9$export$2e2bcd8739ae039).showsForms.update(data.id, response.id);
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};





var $75ef3b576eef8766$export$2e2bcd8739ae039 = {
    execute: async (data)=>{
        const { id: id, form: form, submitBtn: submitBtn } = data;
        const payload = {
            id: id,
            date: form.showdate.value,
            venue: form.venue.value.trim(),
            location: form.location.value.trim(),
            link: form.link.value.trim(),
            soldOut: form.soldout.checked
        };
        const formRequest = (0, $01df58dec21e7277$export$2e2bcd8739ae039)({
            form: form,
            submitBtn: submitBtn
        });
        const response = await (0, $6f42e8eea5ca176e$export$2e2bcd8739ae039).post("/shows/update", payload);
        formRequest.afterResponse(false);
        if (response.success) {
            (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
                resp: response,
                respTitle: "SUCCESS",
                respText: `Show updated successfully.`
            });
            return;
        }
        (0, $bac9fd8885449360$export$2e2bcd8739ae039).show({
            resp: response,
            respTitle: "ERROR",
            respText: response.error
        });
    }
};


function $168be7d73e8d4e17$var$makeEventRouter() {
    const router = {
        "add-show-clicked": (0, $447f7b63ce62b2c2$export$2e2bcd8739ae039)
    };
    const routerWithData = {};
    //@ts-ignore
    const formRouterWithData = {
        "form-created": (0, $4ac7df5f45edcabd$export$2e2bcd8739ae039),
        "form-updated": (0, $75ef3b576eef8766$export$2e2bcd8739ae039),
        "form-deleted": (0, $688b15fcee1bdf36$export$2e2bcd8739ae039)
    };
    return Object.freeze({
        get: get,
        getWithData: getWithData,
        getFormActionWithData: getFormActionWithData
    });
    function get(action) {
        return router[action];
    }
    function getWithData(action) {
        return routerWithData[action];
    }
    function getFormActionWithData(action) {
        return formRouterWithData[action];
    }
}
const $168be7d73e8d4e17$var$APP_VIEWS = $168be7d73e8d4e17$var$makeEventRouter();
var $168be7d73e8d4e17$export$2e2bcd8739ae039 = $168be7d73e8d4e17$var$APP_VIEWS;



function $71c800a94a8d7429$export$2e2bcd8739ae039({ settingsBtn: settingsBtn, settingsOverlay: settingsOverlay, header: header, logo: logo, addBtn: addBtn }) {
    _initAppShell();
    return Object.freeze({
        resize: resize,
        executeEvent: executeEvent,
        executeEventWithData: executeEventWithData,
        executeFormEventWithData: executeFormEventWithData
    });
    function _initAppShell() {
        (0, $0916120d17a98724$export$2e2bcd8739ae039)({
            settingsBtn: settingsBtn,
            settingsOverlay: settingsOverlay
        }).init();
        (0, $e3e66118ecb9a43a$export$2e2bcd8739ae039)({
            header: header,
            logo: logo
        }).init();
        (0, $9ba8302e2b54bc97$export$2e2bcd8739ae039)({
            addBtn: addBtn,
            events: (0, $f5e68e8af16d89cf$export$2e2bcd8739ae039),
            action: "add-show-clicked"
        }).init();
        (0, $da8fed51ab1f97e9$export$2e2bcd8739ae039).showsForms.init();
    }
    function resize() {
        const vh = window.innerHeight / 100;
        (0, $755957079a54393b$export$de7ead42144ee87f).style.setProperty("--vh", vh + "px");
    }
    async function executeEvent(action) {
        const view = (0, $168be7d73e8d4e17$export$2e2bcd8739ae039).get(action);
        await view.execute();
    }
    async function executeEventWithData(detail) {
        const view = (0, $168be7d73e8d4e17$export$2e2bcd8739ae039).getWithData(detail.action);
        await view.execute(detail.data);
    }
    async function executeFormEventWithData(detail) {
        const view = (0, $168be7d73e8d4e17$export$2e2bcd8739ae039).getFormActionWithData(detail.action);
        await view.execute(detail.data);
    }
}


(async function() {
    const overlays = (0, $755957079a54393b$export$3d8c2f653ac9d0b9)(document, ".overlay");
    overlays.forEach((overlay)=>overlay.classList.remove("no-display"));
    const app = (0, $71c800a94a8d7429$export$2e2bcd8739ae039)({
        settingsBtn: (0, $755957079a54393b$export$71511d61b312f219)("settingsBtn"),
        settingsOverlay: (0, $755957079a54393b$export$71511d61b312f219)("settingsOverlay"),
        header: (0, $755957079a54393b$export$71511d61b312f219)("header"),
        logo: (0, $755957079a54393b$export$71511d61b312f219)("logo"),
        addBtn: (0, $755957079a54393b$export$71511d61b312f219)("addBtn"),
        reOrderBtn: (0, $755957079a54393b$export$71511d61b312f219)("reOrderBtn")
    });
    app.resize();
    window.addEventListener("app-event", (e)=>{
        app.executeEvent(e.detail.action);
    });
    window.addEventListener("app-event-with-data", (e)=>{
        app.executeEventWithData(e.detail);
    });
    window.addEventListener("form-event-with-data", (e)=>{
        app.executeFormEventWithData(e.detail);
    });
    window.addEventListener("resize", app.resize);
    document.documentElement.addEventListener("touchstart", function(e) {}); //hover behaviour on touch devices
})();


//# sourceMappingURL=shows.c14dee4f.js.map
